const secrets = {
    third_party_token_set: {
        token_not_found: 'رکورد توکن یافت نشد.',
        access_token_expired: 'توکن دسترسی منقضی شده است. لطفاً حساب خود را دوباره متصل کنید.',
    },
};
export default Object.freeze(secrets);
